import type { ServicesApiEnvHealthAlert } from '@/services/api/services-api';

// Poll frequently when the user is on the health page, or when the
// workspace is not healthy. Poll less aggressively otherwise.
export const WORKSPACE_HEALTH_REFETCH_INTERVAL_ACTIVE = 120_000; // 2 minutes
export const WORKSPACE_HEALTH_REFETCH_INTERVAL_IDLE = 300_000; // 5 minutes

export const DATA_ALERT_SEVERITY_RANK: Record<ServicesApiEnvHealthAlert['severity'], number> = {
  error: 0,
  caution: 1,
  info: 2,
};
